import { render, staticRenderFns } from "./table53.vue?vue&type=template&id=06602504&scoped=true&"
import script from "./table53.vue?vue&type=script&lang=js&"
export * from "./table53.vue?vue&type=script&lang=js&"
import style0 from "./table53.vue?vue&type=style&index=0&id=06602504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06602504",
  null
  
)

export default component.exports